import R from 'ramda';
import { Observable } from 'rxjs';
import { ofTypes } from 'common/epicHelpers';
import { combineEpics } from 'redux-observable';
import * as steps from 'common/steps';
import * as applicationActions from 'application/applicationActions';
import * as submissionActions from './submissionActions';
import { getActiveStep } from './submissionReducer';
import mapSubmissionData from './mapSubmissionData';
import fileHandles from 'file-upload/fileHandles';
import { uploadSubmission } from 'common/stipAjax';

import {
  fetchFromLocalStorage,
  removeObjectFromLocalStorage,
  saveToLocalStorage,
} from 'common/localStorageHelpers';

import {
  doesStepHaveErrors,
  getNextIncompleteStep,
  getOrganizationAlias,
  getProjectId,
  getProjectKey,
  getRedirectUri,
} from 'common/selectors';

const getSubmissionFormData = state => {
  const submissionData = mapSubmissionData(state);

  console.log('submission data: %O', submissionData);

  const submissionBlob = new Blob([JSON.stringify(submissionData)], {
    type: 'application/json',
  });

  const formData = new FormData();
  formData.append('submission-data', submissionBlob);
  formData.append('submission-file', fileHandles.dissertation);

  if (!R.isNil(fileHandles.copyright)) {
    formData.append('copyright-file', fileHandles.copyright);
  }

  return formData;
};

const createKey = state =>
  `${getProjectKey(state)}-${getOrganizationAlias(state)}-submission`;

export const acknowledgeSubmissionEpic = (action$, store) =>
  action$
    .ofType(submissionActions.ACKNOWLEDGE_SUBMISSION_COMPLETE)
    .mergeMap(() =>
      removeObjectFromLocalStorage(createKey(store.getState())).map(() => {
        const redirectUri = getRedirectUri(store.getState());

        if (!R.isEmpty(redirectUri) && !R.isNil(redirectUri)) {
          window.location.href = redirectUri;
          return submissionActions.localStorageSynced();
        } else {
          return submissionActions.cancelSubmission();
        }
      }),
    );

const saveSubmissionToLocalStorage = state =>
  saveToLocalStorage(createKey(state), {
    activeStep: getActiveStep(state.submission),
  });

const loadLocalStorageEpic = (action$, store) =>
  action$
    .ofType(applicationActions.APP_DATA_LOADED)
    .mergeMap(() =>
      fetchFromLocalStorage(createKey(store.getState()))
        .map(submissionActions.localStorageLoaded)
        .catch(R.pipe(applicationActions.appError, Observable.of)),
    );

const syncLocalStorageEpic = (action$, store) =>
  action$
    .filter(
      ofTypes([
        submissionActions.CANCEL_SUBMISSION,
        submissionActions.SET_ACTIVE_STEP,
        submissionActions.SUBMIT,
      ]),
    )
    .debounceTime(200)
    .mergeMap(() =>
      saveSubmissionToLocalStorage(store.getState())
        .map(submissionActions.localStorageSynced)
        .catch(R.pipe(applicationActions.appError, Observable.of)),
    );

const sendSubmissionEpic = (action$, store) =>
  action$.ofType(submissionActions.SEND_SUBMISSION).mergeMap(() => {
    const state = store.getState();

    return uploadSubmission(getSubmissionFormData(state), getProjectId(state))
      .map(
        e =>
          e instanceof ProgressEvent
            ? submissionActions.uploadProgress(
                Math.floor(e.loaded / e.total * 100),
              )
            : submissionActions.uploadComplete(),
      )
      .catch(R.pipe(submissionActions.submissionError, Observable.of))
      .takeUntil(action$.ofType(submissionActions.CANCEL_UPLOAD));
  });

const hasErrors = R.anyPass([
  doesStepHaveErrors(steps.INTRODUCTION),
  doesStepHaveErrors(steps.OPTIONS),
  doesStepHaveErrors(steps.CONTACT_INFO),
  doesStepHaveErrors(steps.DISSERTATION_INFO),
  doesStepHaveErrors(steps.FILE_UPLOAD),
]);

const submitEpic = (action$, store) =>
  action$
    .ofType(submissionActions.SUBMIT)
    .do(() => window.scrollTo(0, 0))
    .map(() => {
      const state = store.getState();

      return hasErrors(state)
        ? submissionActions.invalidSubmission(getNextIncompleteStep(state))
        : submissionActions.sendSubmission();
    });

export default combineEpics(
  acknowledgeSubmissionEpic,
  loadLocalStorageEpic,
  sendSubmissionEpic,
  submitEpic,
  syncLocalStorageEpic,
);



// WEBPACK FOOTER //
// ./src/submission/submissionEpic.js